// Based on: https://lowrey.me/encoding-decoding-base-62-in-es6-javascript/
const base62Charset =
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

export function base62Encode(n: number): string {
  if (n === 0) {
    return '0'
  }
  const prefix = n < 0 ? '-' : ''
  n = Math.abs(n)
  const s: string[] = []
  while (n > 0) {
    s.unshift(base62Charset[n % 62])
    n = Math.floor(n / 62)
  }
  const encodedN = prefix + s.join('')
  return encodedN
}

export function base62Decode(s: string): number {
  const isNegative = s.startsWith('-')
  if (isNegative) {
    s = s.substring(1)
  }
  return (
    (isNegative ? -1 : 1) *
    s
      .split('')
      .reverse()
      .reduce(
        (prev, curr, i) => prev + base62Charset.indexOf(curr) * 62 ** i,
        0,
      )
  )
}
